import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/veterinary/components/Layout.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/veterinary/global.css");
;
import(/* webpackMode: "eager" */ "/var/www/veterinary/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/veterinary/node_modules/sonner/dist/index.mjs");
